<template>
  <div>
    <VueFileAgent
      ref="vueFileAgent"
      :theme="'list'"
      :multiple="false"
      :deletable="true"
      :meta="true"
      :accept="extension"
      :maxSize="'10MB'"
      :maxFiles="1"
      :helpText="textoayuda"
      :errorText="{
        type: 'Tipo de archivo inválido',
        size: 'Los archivos no deben exceder los 10MB de tamaño',
      }"
      @select="filesSelected($event)"
      @beforedelete="onBeforeDelete($event)"
      @delete="fileDeleted($event)"
      :uploadUrl="autoUpload ? uploadUrl : ''"
      :uploadHeaders="uploadHeaders"
      v-model="fileRecords"
    ></VueFileAgent>
  </div>
</template>

<script>
import Vue from "vue";
import VueFileAgent from "vue-file-agent";
import VueFileAgentStyles from "vue-file-agent/dist/vue-file-agent.css";
import global from "@/global";
Vue.use(VueFileAgent);

export default {
  props: {
    File: {
      type: String,
      default: ""
    },
    autoUpload: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      fileRecords: [],
      uploadUrl: "",
      uploadHeaders: {
        'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
      },
      fileRecordsForUpload: [],
      extension: "",
      textoayuda: "",
      varRepeticiones: null
    };
  },
  methods: {
    updateAuthHeaders: function() {
      this.uploadHeaders.Authorization = `Bearer ${localStorage.getItem('token') || ''}`;
      const tenant = sessionStorage.getItem('id_cliente_seleccionado') ||
                     sessionStorage.getItem('idcliente') ||
                     localStorage.getItem('idcliente');
      if (tenant) {
        this.uploadHeaders['X-Tenant-Id'] = tenant;
      }
    },
    reset: function () {
      this.fileRecords = [];
      this.fileRecordsForUpload = [];
      if (this.varRepeticiones) {
        clearInterval(this.varRepeticiones);
      }
    },
    invocar: function (valor) {
      this.$emit("archivosubido", {
        valor: valor,
        fileRecords: this.fileRecords
      });
    },
    funccionn: function (that) {
      var bul = true;
      that.fileRecords.forEach((item) => {
        bul = bul && item.upload && item.upload.data != null;
      });
      if (bul) {
        this.invocar(false);
        clearInterval(this.varRepeticiones);
      }
    },
    funcionnn: function () {
      this.invocar(true);
      var that = this;
      this.varRepeticiones = setInterval(this.funccionn, 500, that);
    },

    filesSelected: function (fileRecordsNewlySelected) {
      var validFileRecords = fileRecordsNewlySelected.filter(
        (fileRecord) => !fileRecord.error
      );
      this.fileRecordsForUpload =
        this.fileRecordsForUpload.concat(validFileRecords);

      if (this.autoUpload) {
        this.funcionnn();
      } else {
        this.invocar(false);
      }
    },
    
    uploadFiles: function () {
      this.$refs.vueFileAgent.upload(
        this.uploadUrl,
        this.uploadHeaders,
        this.fileRecordsForUpload
      );
      this.fileRecordsForUpload = [];
    },
    deleteUploadedFile: function (fileRecord) {
      this.$refs.vueFileAgent.deleteUpload(
        this.uploadUrl,
        this.uploadHeaders,
        fileRecord
      );
    },
    onBeforeDelete: function (fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1);
        var k = this.fileRecords.indexOf(fileRecord);
        if (k !== -1) this.fileRecords.splice(k, 1);
        this.$emit("archivosubido", {
          valor: false,
          fileRecords: this.fileRecords
        });
      } else {
        this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
        this.$emit("archivosubido", {
          valor: false,
          fileRecords: this.fileRecords
        });
      }
    },
    fileDeleted: function (fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord);
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1);
      } else if (this.autoUpload) {
        this.deleteUploadedFile(fileRecord);
      }
      this.$emit("archivosubido", {
        valor: false,
        fileRecords: this.fileRecords
      });
    },
  },
  mounted() {
    const baseApi = (global.ruta_api || "").trim();
    this.uploadUrl = baseApi.endsWith("/") ? baseApi + "imagen/subirimagen" : baseApi + "/imagen/subirimagen";
    this.updateAuthHeaders();
    
    if (this.File == 'excel') {
      this.extension = ".xls";
      this.textoayuda = "Arrastra los archivos aqui para subirlos";
    } else {
      this.extension = "image/*";
      this.textoayuda = "Buscar imágenes";
    }
  },
  beforeDestroy() {
    if (this.varRepeticiones) {
      clearInterval(this.varRepeticiones);
    }
  }
};
</script>
